import React from "react";
import { Modal, Input, Button, message } from "antd";

export default function WebhookSecretModal({ visible, secret, onDismiss }) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      message.success("Copied");
    } catch {
      message.error("Failed to copy");
    }
  };

  return (
    <Modal
      title="Webhook Secret Generated"
      open={visible}
      onCancel={onDismiss}
      width={500}
      closable={false}
      maskClosable={false}
      footer={[
        <Button
          key="dismiss"
          type="primary"
          className="primary-orange-button"
          onClick={onDismiss}
        >
          I've copied it
        </Button>,
      ]}
    >
      <p style={{ fontSize: 13, color: "#555", lineHeight: 1.6, marginBottom: 16 }}>
        Copy this secret now. You won't be able to view it again. Paste it into the{" "}
        <code>X-BluStream-Webhook-Secret</code> header in your Klaviyo Flow's HTTP action.
      </p>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
        <Input.TextArea
          value={secret}
          readOnly
          autoSize={{ minRows: 2, maxRows: 4 }}
          style={{ fontFamily: "monospace", fontSize: 13, flex: 1 }}
        />
        <Button onClick={handleCopy}>Copy</Button>
      </div>
    </Modal>
  );
}
